import { TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_IMAGE } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import { ImageElementEditor } from './components/ImageElement';

export const createImagePlugin = createTElementPluginFactory({
  key: ELEMENT_IMAGE,
  component: withDropTarget(ImageElementEditor as ComponentType<TRenderElementProps>),
  isVoid: true,
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: {
      snapX: false,
      directions: ['s', 'w', 'e', 'sw', 'se'],
      dimensionIndicator: true,
      keepAspectRatio: true,
    },
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/image.png',
      title: 'Image',
      subtitle: 'Upload or add image with a link',
    },
    format: {
      formatType: 'block',
      blurAfterSet: true,
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: [
        'url',
        'height',
        'width',
        'aspect_ratio',
        'align',
        'alt_text',
        'href',
        'internal_link',
        'page_id',
        'open_in_new_tab',
        'mobile_hide',
        'desktop_hide',
        'animation',
        'border_radius',
        'crop',
        'connect_data',
        'margin',
        'border_radius',
        'box_shadow',
      ],
      validChildrenTypes: [],
    },
  },
});
